import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Chip, useTheme } from "@mui/material/index";
import { CBDigitalIdentityState, IFormValues } from "../../types";

const CBDigitalIdentityStatus = () => {

    const theme = useTheme();
    const { t } = useTranslation("customerbase");
    const { control } = useFormContext<IFormValues>();
    const digitalIdentityWatch = useWatch<IFormValues, 'cbDetails.digitalIdentityStatus'>({name: "cbDetails.digitalIdentityStatus"});

    return (
        <>
            {!!digitalIdentityWatch && 
                <Controller
                    control={control}
                    name="cbDetails.digitalIdentityStatus"
                    render={({field}) => (
                        <Chip
                            label={t(`sapEnum.digitalIdentityStatus.${field.value}`)}
                            sx={{color: (field.value == CBDigitalIdentityState.FULL ? "white" : theme.palette.primary.main ), backgroundColor: (field.value == CBDigitalIdentityState.FULL ? theme.palette.success.main : theme.palette.warning.transparent) }}                    
                        />
                    )}             
                />
            }
        </>
    );
}

export default CBDigitalIdentityStatus;